import { useNavigate } from 'react-router-dom';
import { useMyLiquidityCachePositions } from '../hooks/useMyLiquidityCachePositions';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function MyPositionsPage() {
  const { positions, loading, error, refresh } = useMyLiquidityCachePositions();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">My Positions</h1>
        <Button variant="outline" size="sm" onClick={refresh}>
          Refresh
        </Button>
      </div>

      {error && <p className="text-sm text-red-600">{error}</p>}

      {loading && positions.length === 0 ? (
        <p className="text-muted-foreground">Loading positions...</p>
      ) : positions.length === 0 ? (
        <p className="text-muted-foreground">You have no LP positions.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {positions.map((pos) => (
            <Card
              key={pos.positionId}
              className="cursor-pointer hover:border-primary/50 transition-colors"
              onClick={() => navigate(`/a/arche_liquidity_caches/${pos.poolId}`)}
            >
              <CardHeader className="pb-2">
                <CardTitle className="text-base">{pos.pool?.name ?? pos.poolId}</CardTitle>
                {pos.pool && (
                  <p className="text-sm text-muted-foreground">
                    {pos.pool.tokenASymbol} / {pos.pool.tokenBSymbol}
                  </p>
                )}
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div>
                    <p className="text-muted-foreground">Your LP Shares</p>
                    <p className="font-medium">{pos.lpShares}</p>
                  </div>
                  {pos.pool && (
                    <div>
                      <p className="text-muted-foreground">Cache Total</p>
                      <p className="font-medium">{pos.pool.totalLpShares}</p>
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
